import { render, staticRenderFns } from "./InputDetail.vue?vue&type=template&id=9fe908a4&scoped=true"
import script from "./InputDetail.vue?vue&type=script&lang=js"
export * from "./InputDetail.vue?vue&type=script&lang=js"
import style0 from "./InputDetail.vue?vue&type=style&index=0&id=9fe908a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe908a4",
  null
  
)

export default component.exports